import { formatMoney } from '@nemuru-eng/js-api-client';

import { SinglePaymentProviderLogo } from '@/components/modules/Application/components/PaymentMethod/_shared/components/SinglePaymentProviderLogo';
import { SinglePaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/_shared/entities/PaymentMethodDetail/SinglePaymentMethodDetailEntity';
import { ConditionsDescriptionFactory } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/ConditionsAndProgress/Conditions/ConditionsDescriptionFactory';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';

interface ConditionsProps {
  paymentMethodDetailEntity: SinglePaymentMethodDetailEntity;
}

export const Conditions = ({ paymentMethodDetailEntity }: ConditionsProps) => {
  const paymentMethod = paymentMethodDetailEntity.paymentMethod;

  if (!paymentMethod) {
    return null;
  }

  // TODO: When more providers are available, we should change this.
  const providerNames = paymentMethod.getAllProviderNames();

  return (
    <FlexRow alignItems={'flex-start'} gridGap={16}>
      <FlexColumn gridGap={2} minWidth={0}>
        <Font variant="h2" color="title" style={{ wordBreak: 'break-all' }}>
          {formatMoney(paymentMethodDetailEntity.totalAmount)}
        </Font>
        <ConditionsDescriptionFactory paymentMethodType={paymentMethod.paymentMethodType} />
      </FlexColumn>
      <SinglePaymentProviderLogo
        providers={providerNames}
        isActive={!!paymentMethodDetailEntity.paymentMethodId}
        size={80}
      />
    </FlexRow>
  );
};
